module.exports = __webpack_public_path__ + "img/icon_kaitibaogao.de80c128.svg";